import style from './style.css';
import MuiInput from '../../../material-ui/muiInput';
import { getNumericValue } from '../../../../utils/stringOperations';
import withBaseComponent from '../../../../HOC/withBaseComponent';
import { Component } from 'preact';
import RequestButton from '../../../requestButton';
import actionType from '../../../../actions/ntbAction/actionType';
import ResendOTP from '../../../common/resendOtp/resendOTP';
import InstacredTnC from '../../../../components/common/instacredTnC';
import { tracker, UserActionType } from '../../../../tracking';
import ToolTipPromptComponent from '../../../../components/common/toolTipPromptComponent';

class VerifyOtpCheck extends Component {
  state = {
    otp: '',
    isTermsAccepted: false,
    showAcceptTncMsg: false,
  };

  pageKey = 'pv_bic_otp';

  render() {
    const { pageKey, ntbAction, mobileNumber, resendOTP } = this.props || {};
    const { otp, isTermsAccepted, showAcceptTncMsg } = this.state || {};
    return (
      <div className={style.verifyOTPContainer}>
        <div className={style.innerSubText}>
          OTP sent to <span class='bold-text'>{mobileNumber}</span>
        </div>
        <div className={style.otpWrapper}>
          <div className={` greyInputBox ${style.mobileInputContainer}`}>
            <MuiInput
              pageKey={pageKey}
              className={style.inputBox}
              inputPlaceholder='5 digit OTP'
              inputType='tel'
              elementName='bic_enter_otp'
              maxLength={5}
              minLength={5}
              inputValue={otp}
              autoFocus={true}
              onChange={(e) => {
                this.setState({ otp: getNumericValue(e.target.value) });
              }}
            />
          </div>
          <div className={style.otpSubmitButton}>
            <RequestButton
              buttonDisabled={otp.length !== 5}
              buttonId='verify-otp-button'
              pageKey={pageKey}
              buttonWrapperClass={style.submitButton}
              elementName='bic_verify_otp_cta'
              buttonText='VERIFY OTP'
              buttonOnClick={() => {
                if (isTermsAccepted) {
                  this.props.ntbAction(actionType.verifyOTPBic, {
                    mobile: mobileNumber,
                    otp: otp,
                  });
                } else {
                  this.setState({ showAcceptTncMsg: true });
                }
              }}
            />
          </div>
        </div>
        <div className={style.resendAndTncWrapper}>
          <ToolTipPromptComponent
            showMsg={showAcceptTncMsg}
            clearMsg={() => this.setState({ showAcceptTncMsg: false })}
            msg={'Please accept terms & conditions first'}
            shouldUseAutoTimer={true}>
            <InstacredTnC
              isTermsAccepted={isTermsAccepted}
              onClickTermsAccepted={(isTermsAccepted) => {
                this.setState({ isTermsAccepted: isTermsAccepted });
                if (isTermsAccepted) {
                  tracker.trackUserInteraction(
                    UserActionType.SELECT,
                    'bic_ap_accept_t&c',
                    pageKey,
                    '',
                  );
                  this.setState({ showAcceptTncMsg: false });
                }
              }}
              pageKey={pageKey}
            />
          </ToolTipPromptComponent>

          <div className={style.resendOtpContainer}>
            <ResendOTP
              color='rgba(0, 0, 0, 0.8)'
              resendOTP={() => {
                resendOTP();
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default withBaseComponent(VerifyOtpCheck);



// WEBPACK FOOTER //
// ./componentsBICRevamp/buyWithInstacredLanding/overlayEligibiltyCheck/otpInput/index.js